// src/services/api/session.js
// Stable session ID for this page load.
// Generated once per page load; not persisted across refreshes (intentional).
const SESSION_ID = crypto.randomUUID();

export function getSessionId() {
  return SESSION_ID;
}
